import "./newgame.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const NewGame = ({player, createGame}) => {
    console.log("PLAYER", player);
    const navigate = useNavigate();
    const [options, setOptions] = useState({useSupplementalWordList: true, dictionary: "yawl", boardType:"classic", tileSet: "ivory", name: "", isPublic: false});
    const [players, setPlayers] = useState([])
    const [newPlayer, setNewPlayer] = useState({id: 0, email: ""})
    const [creating, setCreating] = useState(false)
    // const friends = [
    //     {id: 7, name: "Arnold"},
    //     {id: 5, name: "Don"},
    //     {id: 6, name: "Eddie"},
    //     {id: 1, name: "Insane Test Pilot"},
    //     {id: 4, name: "Jim"},
    // ]

    useEffect(() => {
        if (!players.length) {
            setPlayers([{id: player.id, name: player.name, email:player.email}]);
        }
    });
    
    const onChangeOptionsHandler = (event) => {
        const isValid = event.target.reportValidity();
        console.log("Options...", event.target.name, isValid);
        event.target.setAttribute("aria-invalid", !isValid);
        setOptions({...options, [event.target.name]: event.target.value});
    }

    const onChangeNewPlayerHandler = (event) => {
        const isValid = event.target.reportValidity();
        event.target.setAttribute("aria-invalid", !isValid);
        let id = 0;
        let email = "";
        if (event.target.name == "id" && event.target.value > 0)  {
            id = event.target.value;
        } else if (event.target.name == "email" && event.target.value) {
            email = event.target.value;
        }
        setNewPlayer({id, email});
    }

    const addPlayer = () => {
        let addPlayer = {...newPlayer};
        if (newPlayer.id) {
            addPlayer = player.friends.find(f => f.id == newPlayer.id);
        } 
        setPlayers([...players, addPlayer]);
        setNewPlayer({id: 0, email: ""});
    }
    const removePlayer = (playerIndex) => {
        console.log(playerIndex, players);
        setPlayers([...players.filter((p, i) => i != playerIndex)])
    }

    const onToggle = (event) => {
        console.log(event.name)
        setOptions({...options, [event.target.name]: !options[event.target.name]});
    }

    const isGameValid = () => {
        console.log(options)
        if (options?.name && options.name.length >= 3) {
            return true;
        } 
        return false;
    }

    const handleCreate = async () => {
        setCreating(true);
        try {
            await createGame(options, players);
            navigate("/");
        } catch (err) {
            console.error("Failed to create game", err);
            setCreating(false);
        }
    }

    return (
        <>
            <h3>New Game</h3>
            <div className="row align-items-start">
                <div className="col-12 col-lg-6 row mb-5 mb-lg-0">
                    <h4 className="col-12">Options</h4>
                    <div className="col-12 mb-2">
                        <div className="form-floating">
    
                            <input name="name" type="text" maxLength={50} minLength={3} className="form-control" id="name" placeholder="Game Name" value={options.name} onChange={onChangeOptionsHandler} />
                            <label htmlFor="name">Game Name</label>
    
                        </div>
                    </div>
                    <div className="col-6 mb-2">
                        <div className="form-floating">
                            <select name="boardType" value={options.boardType} onChange={onChangeOptionsHandler} className="form-select" id="boardType" aria-label="Board type selection">
                                <option value="classic">Classic</option>
                                <option value="super">Super</option>
                                <option value="mini">Mini</option>
                            </select>
                            <label htmlFor="boardType">Board</label>
                        </div>
                    </div>
                    <div className="col-6 mb-2">
                        <div className="form-floating">
                            <select name="tileSet" value={options.tileSet} onChange={onChangeOptionsHandler} className="form-select" id="tileSet" aria-label="Tile set selection">
                                <option value="ivory">Ivory</option>
                                <option value="red">Red</option>
                                <option value="wood">Wood</option>
                            </select>
                            <label htmlFor="tileSet">Tiles</label>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 mb-2">
                        <div className="form-floating">
                            <select name="dictionary" value={options.dictionary} onChange={onChangeOptionsHandler} className="form-select" id="dictionary" aria-label="Dictionary Selection">
                                <option value="yawl">Yet Another Word List (YAWL)</option>
                                <option value="ospd">Official Scrabble Players Dictionary (OSPD)</option>
                                <option value="otcwl">NASPA Word List (OTCWL)</option>
                            </select>
                            <label htmlFor="dictionary">Word List for Challenges</label>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="form-check form-switch">
                            <input name="useSupplementalWordList" className="form-check-input" type="checkbox" id="useSupplemental" checked={options.useSupplementalWordList} onChange={onToggle} />
                            <label className="form-check-label" htmlFor="useSupplemental" style={{hyphens: "auto"}}>Use Supplemental Word List for Challenges</label>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="form-check form-switch">
                            <input name="isPublic" className="form-check-input" type="checkbox" id="isPublic" checked={options.isPublic} onChange={onToggle} />
                            <label className="form-check-label" htmlFor="isPublic">Make this game visible to everyone</label>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-lg-6 row mb-3">
                    <h4 className="col-12">Players</h4>
                    <div className="col-12 col-lg-5 mb-2">
                        <div className="form-floating">
                            <select name="id" value={newPlayer.id} onChange={onChangeNewPlayerHandler} className="form-select" id="dictionary" aria-label="Existing Friend">
                                <option value={0}></option>
                                {player.friends.map((f, i) => (<option key={`option${i}`} value={f.id}>{f.name}</option>))}
                                
                            </select>
                            <label htmlFor="floatingSelect">Select friend</label>
                        </div>
                    </div>
                    <div className="col-9 col-lg-5">
                        <div className="form-floating">
                        <input name="email" type="email" className="form-control" id="addEmail" placeholder="or Add by Email" value={newPlayer.email} onChange={onChangeNewPlayerHandler} />
                        <label htmlFor="name">or Add by Email</label>
                        </div>
                    </div>
                    <div className="col-3 d-block d-lg-none">
                        <div className="form-floating h-100"><button onClick={addPlayer}  className=" btn btn-lg btn-success " style={{width: "100%", padding: ".5rem"}}>Add</button></div>
                    </div>
                    <div className="col-2 d-none d-lg-block">
                        <button onClick={addPlayer} disabled={players.length >= 4 || (!newPlayer.id && !newPlayer.email)} className=" btn btn-lg btn-success " style={{width: "100%", padding: ".5rem"}}>Add</button>
                    </div>
                    <div className="playerList col-12 mt-2">
                        {players.map((p, i) => (
                        <div key={`player${i}`} className="d-flex justify-content-between mb-2">
                            <div className="playerName">{p.name || p.email}</div>
                            <button onClick={() => removePlayer(i)} className={`btn btn-danger ${i == 0 ? "d-none" : ""}`}>Remove</button>
                        </div>
                        ))}
                    </div>
                </div>
                <div className="col-12">
                    <button onClick={handleCreate} disabled={creating || !isGameValid()} className="btn btn-lg btn-success w-100">
                        {creating ? "Creating Game..." : `Create New ${players.length === 1 ? "Solitaire" : `${players.length} Player`} Game`}
                    </button>
                </div>
            </div>
        </>
    )
}

export default NewGame;